import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../config";
import ChatModal from "../components/ChatBox";
import useTitle from "../hooks/useTitle";

export default function Astrologers() {
  useTitle("Astrologers | Astro Portal");
  const [astrologers, setAstrologers] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const authSession = sessionStorage.getItem("authSession");
  const authData = authSession ? JSON.parse(authSession) : null;
  const token = authData?.jwt_token || null;
  const loggedInUserId = authData?.user?.id || null;
  const role = authData?.role || "user";
  const [activeChat, setActiveChat] = useState(null);

  // useEffect(() => {
  //   const dummyApiResponse = [
  //     {
  //       id: 1,
  //       profile: "https://randomuser.me/api/portraits/men/45.jpg",
  //       first_name: "Rahul",
  //       last_name: "Sharma",
  //       primary_skills: "Vedic Astrology",
  //       all_skills: "Vedic, Tarot, Palmistry",
  //       experience: 8,
  //       languages: "Hindi, English",
  //       facebook: "https://facebook.com",
  //       instagram: "https://instagram.com",
  //       linkedin: "https://linkedin.com",
  //       youtube: "https://youtube.com",
  //     },
  //     {
  //       id: 2,
  //       profile: "https://randomuser.me/api/portraits/women/65.jpg",
  //       first_name: "Priya",
  //       last_name: "Verma",
  //       primary_skills: "Tarot Reading",
  //       all_skills: "Tarot, Numerology, Reiki",
  //       experience: 5,
  //       languages: "English, Marathi",
  //       facebook: "",
  //       instagram: "https://instagram.com",
  //       linkedin: "",
  //       youtube: "",
  //     },
  //     {
  //       id: 3,
  //       profile: "https://randomuser.me/api/portraits/men/32.jpg",
  //       first_name: "Amit",
  //       last_name: "Patel",
  //       primary_skills: "Numerology",
  //       all_skills: "Numerology, Vastu Shastra",
  //       experience: 10,
  //       languages: "Gujarati, Hindi",
  //       facebook: "https://facebook.com",
  //       instagram: "",
  //       linkedin: "",
  //       youtube: "",
  //     },
  //   ];

  //   // mimic API delay
  //   setTimeout(() => {
  //     setAstrologers(dummyApiResponse);
  //   }, 800);
  // }, []);

  const fetchAstrologers = async () => {
    try {
      setLoading(true);

      const res = await axios.get(`${API_BASE_URL}/astrologers`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data?.status) {
        setAstrologers(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching astrologers:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAstrologers();
  }, []);
  return (
    <div className="container my-5">
      <h2 className="fw-bold text-primary mb-4 text-center">
        🌟 Meet Our Expert Astrologers
      </h2>

      <div className="row g-4">
        {astrologers.length === 0 ? (
          <p className="text-center text-muted">Loading astrologers...</p>
        ) : (
          astrologers.map((astro) => (
            <div key={astro.id} className="col-md-4">
              <div
                className="card border-0 rounded-4 h-100 shadow-lg"
                style={{ transition: "0.3s" }}
              >
                {/* Profile Image */}
                <div className="text-center mt-4">
                  <img
                    src={astro.profile_photo}
                    alt={astro.first_name}
                    className="rounded-circle border shadow-sm"
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "cover",
                    }}
                  />
                </div>

                <div className="card-body text-center">
                  {/* Name */}
                  <h5 className="fw-bold text-dark mt-2">
                    {astro.first_name} {astro.last_name}
                  </h5>
                  {/* Experience & skills */}
                  <p className="mb-1">
                    <strong>Experience:</strong> {astro.experience_years} yrs
                  </p>
                  <p className="mb-2">
                    <strong>Skills:</strong> {astro.specialization}
                  </p>

                  {/* Social Links */}
                  <div className="d-flex justify-content-center gap-3 mb-3">
                    {astro.facebook && (
                      <a href={astro.facebook} target="_blank" rel="noreferrer">
                        <i className="bi bi-facebook fs-5 text-primary"></i>
                      </a>
                    )}
                    {astro.instagram && (
                      <a
                        href={astro.instagram}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="bi bi-instagram fs-5 text-danger"></i>
                      </a>
                    )}
                    {astro.linkedin && (
                      <a href={astro.linkedin} target="_blank" rel="noreferrer">
                        <i className="bi bi-linkedin fs-5 text-info"></i>
                      </a>
                    )}
                    {astro.youtube && (
                      <a href={astro.youtube} target="_blank" rel="noreferrer">
                        <i className="bi bi-youtube fs-5 text-danger"></i>
                      </a>
                    )}
                  </div>

                  {/* Book Button */}
                  <button
                    className="btn bg-orange text-white fw-bold rounded-pill px-4"
                    onClick={() =>
                      navigate("/booking", { state: { astrologer: astro } })
                    }
                  >
                    Book Now
                  </button>
                  <button
                    className="btn btn-success rounded-pill px-4 ms-2"
                    onClick={() => {
                      if (!authSession) {
                        navigate("/login");
                      } else {
                        navigate("/profile", {
                          state: {
                            tab: "messages",
                            openChat: {
                              astrologer_id: astro.id,
                            },
                          },
                        });
                      }
                    }}
                  >
                    Chat
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      {activeChat && (
        <ChatModal
          astrologer={activeChat}
          user_id={loggedInUserId}
          sender={role === "astrologer" ? "astrologer" : "user"}
          token={token}
          onClose={() => setActiveChat(null)}
        />
      )}
    </div>
  );
}
